import type { Corporation, WithContext } from 'schema-dts';

import { AHM_CORPORATION } from '../../constants';

const buildCorporationSchema = (): WithContext<Corporation> => ({
  '@context': 'https://schema.org',
  '@id': AHM_CORPORATION.ID,
  '@type': 'Corporation',
  areaServed: AHM_CORPORATION.AREA_SERVED,
  contactPoint: [...AHM_CORPORATION.CONTACT_POINTS],
  description: AHM_CORPORATION.DESCRIPTION,
  email: AHM_CORPORATION.EMAIL,
  foundingDate: AHM_CORPORATION.FOUNDING_DATE,
  image: AHM_CORPORATION.IMAGE_URL,
  knowsAbout: AHM_CORPORATION.KNOWS_ABOUT,
  legalName: AHM_CORPORATION.LEGAL_NAME,
  logo: AHM_CORPORATION.LOGO_URL,
  name: AHM_CORPORATION.NAME,
  parentOrganization: AHM_CORPORATION.PARENT_ORGANIZATION,
  sameAs: [...AHM_CORPORATION.SAME_AS],
  telephone: AHM_CORPORATION.TELEPHONE,
  url: AHM_CORPORATION.URL,
});

export default buildCorporationSchema;
